import React from 'react';
import type {
  LoadAssetViewProps,
} from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';
import { ListAssetsView } from './ListAssetsView';

const LoadAssetFilters = withErrorBoundary(
  React.lazy(() => import('../../../micro-frontends/components/AssetFilters')),
);

export const AssetsWithFilteringView = (props: LoadAssetViewProps) => (
  <div className="flex gap-2">
    <ListAssetsView {...props.data} />
    <span className="min-w-[280px] rounded-md bg-white dark:bg-gray-800">
      <LoadAssetFilters {...(props.data as any)} />
    </span>
  </div>
);
